<template>
  <div class="container exam-create">
    <div class="header">
      <el-breadcrumb class="breadcrumb"
                     separator="/">
        <el-breadcrumb-item>内容管理</el-breadcrumb-item>
        <el-breadcrumb-item :to="{ path: '/exam/list' }">在线题库</el-breadcrumb-item>
        <el-breadcrumb-item>题库创建</el-breadcrumb-item>
      </el-breadcrumb>
      <div class="content">
        <div class="left">
          <div class="left-item">
            <span style="margin:16px;">产品经理:</span>
            <el-autocomplete class="inline-input"
                             v-model="manager_admin_id"
                             :fetch-suggestions="querySearch"
                             placeholder="请输入内容"
                             :trigger-on-focus="false"
                             @select="handleSelect"
                             clearable
                             style="width: 300px;margin-left:16px;"></el-autocomplete>
          </div>
        </div>
        <div class="right">
          <el-button plain
                     @click="handleClose">取消</el-button>
          <el-button type="primary"
                     @click="handleSubmit">保存</el-button>
        </div>
      </div>
    </div>
    <div class="main">
      <h3 class="title">题库详情设置</h3>
      <div class="content">
        <el-form class="dataForm"
                 :model="dataForm"
                 :rules="rules"
                 ref="dataForm"
                 label-width="110px">
          <div class="form-header">
            <div class="form-header-inner">基础信息</div>
          </div>
          <el-form-item label="上传主图："
                        prop="picture_url">
            <div class="cover-wrap">
              <div class="top">
                <div class="left">
                  <el-image class="cover-selected"
                            :src="dataForm.picture_url"
                            fit="cover" />
                  <p class="label">当前主图</p>
                </div>
                <div class="middle"></div>
                <div class="right">
                  <div class="covers">
                    <el-image class="cover-item"
                              fit="cover"
                              v-for="(item, index) in covers"
                              :key="index"
                              :src="item"
                              @click="handleCoverChange(item)" />
                  </div>
                  <p class="label">备选主图</p>
                </div>
              </div>
              <div>
                <el-upload class="avatar-uploader"
                           :action="imgUploadUrl"
                           :headers="uploadHeaders"
                           :show-file-list="false"
                           :on-success="handleUploadSuccess"
                           :before-upload="handleBeforeUpload">
                  <el-button size="small"
                             plain><i class="el-icon-upload2" />自定义主图</el-button>
                  <div slot="tip"
                       class="el-upload__tip">
                    支持扩展名：.jpg .png .jpge ; 建议图片尺寸为750*422
                  </div>
                </el-upload>
              </div>
            </div>
          </el-form-item>
          <el-form-item label="题库名称："
                        prop="name">
            <el-input v-model="dataForm.name"
                      placeholder="输入题库名称"></el-input>
          </el-form-item>
          <el-form-item label="题库简介："
                        prop="description">
            <el-input v-model="dataForm.description"
                      placeholder="输入题库简介"
                      type="textarea"
                      :rows="2"></el-input>
          </el-form-item>
          <el-form-item label="题库标签："
                        prop="tags">
            <el-input v-model="dataForm.tags"
                      placeholder="输入题库标签，多个用英文逗号隔开"></el-input>
          </el-form-item>
          <el-form-item label="题库类型："
                        prop="exam_type">
            <el-select v-model="dataForm.exam_type"
                       placeholder=""
                       style="width: 300px">
              <el-option v-for="item in filter.types"
                         :key="item.value"
                         :label="item.label"
                         :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="适合科目："
                        prop="subjects">
            <div class="tag-wrap">
              <el-tag class="subject-item"
                      size="medium"
                      :key="item.id"
                      v-for="item in subjects"
                      closable
                      :disable-transitions="false"
                      @close="handleSubjectRemove(item)">
                {{
                  item.college_name
                    ? `${item.college_name}-${item.name}`
                    : item.name
                }}
              </el-tag>
              <el-button type="text"
                         @click="handleSubjectChoose">选择科目</el-button>
            </div>
          </el-form-item>
          <el-form-item label="适合专业："
                        prop="majors">
            <div class="tag-wrap">
              <el-tag class="subject-item"
                      size="medium"
                      :key="item.id"
                      v-for="item in majors"
                      closable
                      :disable-transitions="false"
                      @close="handleMajorRemove(item)">
                {{ `${item.name}/${item.code}` }}
              </el-tag>
              <el-button type="text"
                         @click="handleMajorChoose">选择专业</el-button>
            </div>
          </el-form-item>
          <el-form-item label="适合院校："
                        prop="colleges">
            <div class="tag-wrap">
              <el-tag class="subject-item"
                      size="medium"
                      :key="item.id"
                      v-for="item in colleges"
                      closable
                      :disable-transitions="false"
                      @close="handleCollegeRemove(item)">
                {{ `${item.name}` }}
              </el-tag>
              <el-button type="text"
                         @click="handleCollegeChoose">选择院校</el-button>
            </div>
          </el-form-item>
          <div class="form-item-wrap">
            <el-form-item class="price"
                          label="售价："
                          prop="price">
              <el-input v-model="dataForm.price"
                        placeholder="输入售价"></el-input>
            </el-form-item>
            <el-form-item label="划线价："
                          prop="market_price">
              <el-input v-model="dataForm.market_price"
                        placeholder="输入划线价"></el-input>
            </el-form-item>
          </div>
          <el-form-item label="可试用次数："
                        prop="trial_count">
            <el-select class="free-num"
                       v-model="dataForm.trial_count"
                       placeholder=""
                       style="width: 300px">
              <el-option v-for="item in filter.trial_counts"
                         :key="item.value"
                         :label="item.label"
                         :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="发布人："
                        prop="author_id">
            <el-select v-model="dataForm.author_id"
                       filterable
                       remote
                       reserve-keyword
                       :remote-method="fetchAuthorList"
                       placeholder="搜索作者，选择保存"
                       style="width: 300px">
              <el-option :label="`${item.realname}/${item.mobile}`"
                         :value="item.id"
                         v-for="item in authors"
                         :key="item.id"></el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="协议编码"
                        prop="product_agreement_codes">
            <el-select v-model="dataForm.product_agreement_codes"
                       placeholder="选择协议编码"
                       multiple
                       style="width: 300px">
              <el-option v-for="item in $store.state.agreementList||[]"
                         :key="item.id"
                         :label="item.name"
                         :value="item.code">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="排序值：">
            <el-input v-model="dataForm.sort"
                      placeholder="输入排序值"
                      style="width:300px;"
                      oninput="value=value.replace(/[^0-9.]/g,'')"></el-input>
          </el-form-item>
          <div class="form-header">
            <div class="form-header-inner">服务老师</div>
          </div>
          <Teacher :content="{ teachers: teachers }"
                   @save="saveTeacher" />
          <div class="form-header">
            <div class="form-header-inner">详情描述</div>
          </div>
          <el-form-item class="course-detail"
                        label="题库详情："
                        prop="detail">
            <UEeditor :setDataStr="dataForm.detail"
                      @change="initDtaForm" />
          </el-form-item>
        </el-form>
      </div>
    </div>
    <SubjectChoose :visible="subjectChooseDialog"
                   :subjects="subjects"
                   @close="subjectChooseDialog = false"
                   @submit="saveSubject"></SubjectChoose>
    <MajorChoose :visible="majorChooseDialog"
                 :majors="majors"
                 @close="majorChooseDialog = false"
                 @submit="saveMajor"></MajorChoose>
    <CollegeChoose :visible="collegeChooseDialog"
                   :colleges="colleges"
                   @close="collegeChooseDialog = false"
                   @submit="saveCollege"></CollegeChoose>
  </div>
</template>

<script>
import Teacher from '../product/teacher'
import SubjectChoose from '@/components/dialog/subject/SubjectChoose'
import MajorChoose from '@/components/dialog/major/MajorChoose'
import CollegeChoose from '@/components/dialog/college/CollegeChoose'
import { imgUploadUrl, uploadHeaders } from '@/config/index'
import { examCreate } from '@/api/exam'
import { seniorList } from '@/api/senior'
import UEeditor from '@/components/UEeditor'
import { getStorage } from '@/utils/helper'

export default {
  components: {
    Teacher,
    SubjectChoose,
    MajorChoose,
    CollegeChoose,
    UEeditor,
  },
  data() {
    return {
      loading: false,
      subjectChooseDialog: false,
      majorChooseDialog: false,
      collegeChooseDialog: false,
      imgUploadUrl: imgUploadUrl(),
      uploadHeaders: uploadHeaders(),
      covers: [
        'https://upload.kaoyanbox.net/exam_political.png',
        'https://upload.kaoyanbox.net/exam_english_1.png',
        'https://upload.kaoyanbox.net/exam_english_2.png',
        'https://upload.kaoyanbox.net/exam_math_1.png',
        'https://upload.kaoyanbox.net/exam_math_2.png',
        'https://upload.kaoyanbox.net/exam_math_3.png',
        'https://upload.kaoyanbox.net/exam_management.png',
        'https://upload.kaoyanbox.net/exam_common.png',
      ],
      dataForm: {
        picture_url: '',
        trial_count: 0,
        exam_type: 1,
      },
      subjects: [],
      majors: [],
      colleges: [],
      teachers: [],
      authors: [],
      filter: {
        types: [
          { label: '考点练习', value: 1 },
          { label: '冲刺押题', value: 2 },
          { label: '历年真题', value: 3 },
          { label: '挑战刷题', value: 4 },
          { label: '名师题库', value: 5 },
          { label: '参考书配套题库', value: 6 },
        ],
        trial_counts: [
          { label: '无试用', value: 0 },
          { label: '1次', value: 1 },
          { label: '2次', value: 2 },
          { label: '3次', value: 3 },
          { label: '4次', value: 4 },
          { label: '5次', value: 5 },
          { label: '6次', value: 6 },
          { label: '7次', value: 7 },
          { label: '8次', value: 8 },
        ],
      },
      rules: {
        name: [
          { required: true, message: '请输入题库名称', trigger: 'blur' },
          {
            min: 3,
            max: 30,
            message: '长度在 3 到 30 个字符',
            trigger: 'blur',
          },
        ],
        description: [
          { required: true, message: '请输入题库介绍', trigger: 'blur' },
          {
            min: 3,
            max: 50,
            message: '长度在 3 到 50 个字符',
            trigger: 'blur',
          },
        ],
        detail: [
          { required: true, message: '请输入题库详情', trigger: 'blur' },
        ],
        market_price: [
          { required: true, message: '请输入划线价', trigger: 'blur' },
        ],
        price: [{ required: true, message: '请输入售价', trigger: 'blur' }],
        trial_count: [
          { required: true, message: '请选择可试用次数', trigger: 'blur' },
        ],
        author_id: [
          { required: false, message: '请选择作者/学长', trigger: 'blur' },
        ],
        exam_type: [
          { required: true, message: '请选择题库类型', trigger: 'change' },
        ],
        picture_url: [
          {
            required: true,
            message: '请上传主图',
            trigger: 'change',
            validator: (rule, value, callback) => {
              if (!this.dataForm.picture_url) {
                return callback(new Error(rule.message))
              } else {
                callback()
              }
            },
          },
        ],
        subjects: [
          {
            required: true,
            message: '请选择适合科目',
            trigger: 'change',
            validator: (rule, value, callback) => {
              if (!this.subjects.length) {
                return callback(new Error(rule.message))
              } else {
                callback()
              }
            },
          },
        ],
      },
      manager_admin_id: '',
    }
  },
  mounted() {
    this.$store.dispatch('getAdminList')
    this.$store.dispatch('fetchAgreementList')
    this.manager_admin_id = getStorage('admin_user').nickname
    this.dataForm.manager_admin_id = getStorage('admin_user').id
  },
  methods: {
    fetchAuthorList(name) {
      seniorList({ keyword: name, isPaging: 0 }).then((res) => {
        this.authors = res.list
      })
    },
    handleDetailChange(editor) {
      this.dataForm.detail = editor.html
    },
    handleSubmit() {
      this.$refs['dataForm'].validate((valid) => {
        if (valid) {
          let params = Object.assign({}, this.dataForm, {
            subjects: this.subjects.map((item) => ({
              code: item.code,
              college_code: item.college_code,
            })),
            majors: this.majors.map((item) => ({
              code: item.code,
              college_code: item.college_code,
            })),
            colleges: this.colleges.map((item) => ({ code: item.code })),
            teachers: this.teachers.map((item) => ({
              id: item.id,
              type: item.type,
              sort: item.sort,
            })),
            product_agreement_codes:
              this.dataForm.product_agreement_codes.join(','),
          })
          params.market_price = Number(params.market_price)
          params.price = Number(params.price)
          examCreate(params)
            .then((res) => {
              this.$message.success(`创建成功`)
              this.$refs['dataForm'].resetFields()

              this.handleClose()
            })
            .catch((error) => {
              console.log('error: ', error)
            })
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    handleSubjectRemove(item) {
      this.subjects = this.subjects.filter((v) => v.id !== item.id)
    },
    handleSubjectChoose() {
      this.subjectChooseDialog = true
    },
    saveSubject({ subjects }) {
      this.subjects = subjects
    },
    handleMajorRemove(item) {
      this.majors = this.majors.filter((v) => v.id !== item.id)
    },
    handleMajorChoose() {
      this.majorChooseDialog = true
    },
    saveMajor({ majors }) {
      this.majors = majors
    },
    handleCollegeRemove(item) {
      this.colleges = this.colleges.filter((v) => v.id !== item.id)
    },
    handleCollegeChoose() {
      this.collegeChooseDialog = true
    },
    saveCollege({ colleges }) {
      this.colleges = colleges
    },
    saveTeacher({ teachers }) {
      this.teachers = teachers
    },
    handleClose() {
      this.$router.go(-1)
    },
    handleUploadSuccess(res, file) {
      if (res.code == 0 && res.data) {
        this.dataForm.picture_url = res.data.url
      } else {
        this.$message.error(res.error)
      }
    },
    handleBeforeUpload(file) {
      const isLt2M = file.size / 1024 / 1024 < 5

      if (!isLt2M) {
        this.$message.error('上传头像图片大小不能超过 5MB!')
      }
      return isLt2M
    },
    handleCoverChange(url) {
      this.dataForm.picture_url = url
    },
    initDtaForm(e) {
      this.dataForm.detail = e
    },
    querySearch(queryString, cb) {
      var restaurants = this.$store.state.adminList.map((v) => {
        return {
          value: v.nickname,
          id: v.id,
        }
      })
      var results = queryString
        ? restaurants.filter(this.createFilter(queryString))
        : restaurants
      // 调用 callback 返回建议列表的数据
      cb(results)
    },
    createFilter(queryString) {
      return (restaurant) => {
        return (
          restaurant.value.toLowerCase().indexOf(queryString.toLowerCase()) ===
          0
        )
      }
    },
    handleSelect(item) {
      this.dataForm.manager_admin_id = item.id
    },
  },
}
</script>

<style scoped lang="less">
.exam-create {
  .header {
    background: #fff;
    padding: 20px;

    .breadcrumb {
      margin-bottom: 20px;
    }
    .content {
      display: flex;
      justify-content: space-between;
      align-items: center;
    }
  }
  .main {
    background: #fff;
    padding: 20px;
    margin-top: 10px;

    .title {
      font-size: 32px;
      font-weight: bold;
    }
  }
  .content {
    display: flex;
    margin-top: 20px;

    .dataForm {
      min-width: 700px;
      width: 100%;
    }

    .button {
      font-size: 14px;
      padding: 12px 20px;
      margin-bottom: 10px;

      &.small {
        padding: 9px 15px;
      }
    }
    .cover-wrap {
      .top {
        display: flex;
        margin-bottom: 10px;
      }
      .left,
      .right {
        display: flex;
        flex-direction: column;
        align-items: center;
      }
      .middle {
        flex: 1;
      }
      .cover-selected {
        height: 92px;
      }
      .covers {
        display: flex;
        flex-wrap: wrap;
        justify-content: center;
        align-content: space-between;
        width: 300px;
      }
      .cover-item {
        width: 70px;
        height: 70px;
        cursor: pointer;
        margin-bottom: 5px;

        &:not(:nth-child(4n)) {
          margin-right: 5px;
        }
      }
      .el-upload__tip {
        line-height: 20px;
      }
    }
    .form-item-wrap {
      display: flex;

      /deep/ .el-input {
        width: 300px;
      }
    }
    .tag-wrap {
      display: flex;
      flex-wrap: wrap;
    }
    .subject-item,
    .teacher-item {
      margin-right: 5px;
      margin-bottom: 5px;
    }
  }

  .form-header {
    font-size: 14px;
    font-weight: bold;
    color: #333;
    background: #f8f8f8;
    margin-bottom: 20px;

    .form-header-inner {
      padding: 10px;
    }
  }
}
</style>
